/* eslint-disable no-extend-native -- bilinçli native polyfill */
// Prerender/legacy ortam polyfill'leri.
//
// react-snap, puppeteer 1.20 (Chromium ~78) kullanır; pdfjs-dist ise
// Array.prototype.at, String.prototype.at, String.prototype.replaceAll ve
// structuredClone gibi daha yeni built-in'leri kullanır. Modern tarayıcılarda
// bu polyfill'ler no-op'tur; yalnız eski prerender Chromium'unda devreye girer
// (/shop, /favorites gibi pdfjs yükleyen sayfaların prerender'ı çökmesin).

if (typeof Array.prototype.at !== 'function') {
  Object.defineProperty(Array.prototype, 'at', {
    value: function at(n) {
      n = Math.trunc(n) || 0;
      if (n < 0) n += this.length;
      if (n < 0 || n >= this.length) return undefined;
      return this[n];
    },
    writable: true,
    configurable: true,
  });
}

if (typeof String.prototype.at !== 'function') {
  Object.defineProperty(String.prototype, 'at', {
    value: function at(n) {
      n = Math.trunc(n) || 0;
      if (n < 0) n += this.length;
      if (n < 0 || n >= this.length) return undefined;
      return this[n];
    },
    writable: true,
    configurable: true,
  });
}

if (typeof String.prototype.replaceAll !== 'function') {
  Object.defineProperty(String.prototype, 'replaceAll', {
    value: function replaceAll(search, replacement) {
      const str = String(this);
      if (search instanceof RegExp) {
        if (!search.global) {
          throw new TypeError('replaceAll must be called with a global RegExp');
        }
        return str.replace(search, replacement);
      }
      return str.split(String(search)).join(String(replacement));
    },
    writable: true,
    configurable: true,
  });
}

if (typeof window !== 'undefined' && typeof window.structuredClone !== 'function') {
  window.structuredClone = function structuredClone(value) {
    if (value === null || typeof value !== 'object') return value;
    if (value instanceof Date) return new Date(value.getTime());
    if (value instanceof RegExp) return new RegExp(value.source, value.flags);
    if (value instanceof ArrayBuffer) return value.slice(0);
    if (ArrayBuffer.isView(value)) {
      return typeof value.slice === 'function' ? value.slice() : value;
    }
    if (value instanceof Map) {
      const map = new Map();
      value.forEach((v, k) => map.set(structuredClone(k), structuredClone(v)));
      return map;
    }
    if (value instanceof Set) {
      const set = new Set();
      value.forEach((v) => set.add(structuredClone(v)));
      return set;
    }
    if (Array.isArray(value)) return value.map(structuredClone);
    const clone = {};
    for (const key of Object.keys(value)) clone[key] = structuredClone(value[key]);
    return clone;
  };
}
